import { Link } from "react-router-dom";

export default function CtaBand() {
  return (
    <section className="w-full px-4 md:px-8 py-14 md:py-20">
      <div className="reveal w-full rounded-lg bg-primary-500 text-background-50 px-6 md:px-12 py-10 md:py-14">
        <div className="flex flex-col lg:flex-row lg:items-center lg:justify-between gap-8">
          <div className="max-w-2xl">
            <span className="text-xs tracking-[0.22em] uppercase text-primary-100">
              Join the talk
            </span>
            <h2 className="mt-3 text-2xl md:text-4xl font-bold leading-snug text-balance">
              同一个瓜，本来就该有不同的吃法
            </h2>
            <p className="mt-4 text-sm md:text-base leading-relaxed text-primary-50/90">
              支持、质疑、中立，三种立场在讨论区同样重要。说出你的判断，也看看别人为什么不同意。
            </p>
          </div>

          <div className="flex flex-col sm:flex-row lg:flex-col xl:flex-row gap-3 shrink-0">
            <Link
              to="/discussion"
              className="inline-flex items-center justify-center gap-2 px-6 py-3 rounded-full bg-background-50 text-primary-800 text-sm whitespace-nowrap hover:bg-background-100 transition-colors duration-200"
            >
              <i className="ri-edit-2-line w-4 h-4 flex items-center justify-center" />
              写下我的观点
            </Link>
            <Link
              to="/about"
              className="inline-flex items-center justify-center gap-2 px-6 py-3 rounded-full border border-primary-200/70 text-background-50 text-sm whitespace-nowrap hover:bg-primary-600 transition-colors duration-200"
            >
              了解我们
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
}